export default __webpack_public_path__ + "static/project-slide-4-4032-2268-66e3543729a40b5599dc30f00796b154.jpg";